"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormColumn2Wide = _styledComponents["default"].div.attrs(function () {
  return {
    className: "col-lg-6 col-md-12 col-sm-12"
  };
}).withConfig({
  displayName: "FormColumn2Wide",
  componentId: "sc-9t1n7i-0"
})([""]);

var _default = FormColumn2Wide;
exports["default"] = _default;